const SOLDER_RATES = {
    1: 0.03,
    2: 0.03,
    3: 0.02,
    4: 0.02,
    5: 0.02,
    6: 0.12,
    7: 0.01,
    8: 0.02,
    9: 0.02,
}

const getMetalWeight = (targetWeight, solderRate) => Number(targetWeight) / (1 + solderRate)

const roundToTwo = (value) => parseFloat(Number(value).toFixed(2))

const finalizeCalculation = (resultObj) => {
    for (let key in resultObj) {
        if (typeof resultObj[key] === 'number') {
            resultObj[key] = roundToTwo(resultObj[key])
        }
    }

    resultObj.weightWithSolder = roundToTwo(resultObj.weight)
    resultObj.weightNotSolder = roundToTwo(resultObj.weightNotSolder)
    resultObj.solder = roundToTwo(resultObj.weightWithSolder - resultObj.weightNotSolder)

    return resultObj
}

export function useCalculator() {
    const calculations = {
        1: (resultChainParams) => {
            let resultObj = {...resultChainParams}
            const metalWeight = getMetalWeight(resultObj.weight, SOLDER_RATES[1])
            resultObj.diameter = Math.sqrt((17 * metalWeight) / resultObj.long / resultObj.density)
            resultObj.rigelDiameter = resultObj.diameter * resultObj.k
            resultObj.weightNotSolder = resultObj.diameter * resultObj.diameter * resultObj.long * resultObj.density / 17
            // resultObj.widthAfter = 2 * resultObj.rigelDiameter + 0.5 * resultObj.diameter
            // resultObj.widthBefore = resultObj.rigelDiameter + 1.2 * resultObj.diameter
            return finalizeCalculation(resultObj)
        },
        2: (resultChainParams) => {
            let resultObj = {...resultChainParams}
            const metalWeight = getMetalWeight(resultObj.weight, SOLDER_RATES[2])
            resultObj.diameter = Math.sqrt((15 * metalWeight) / resultObj.long / resultObj.density)
            resultObj.rigelDiameter = resultObj.diameter * resultObj.k
            resultObj.weightNotSolder = resultObj.diameter * resultObj.diameter * resultObj.long * resultObj.density / 15
            return finalizeCalculation(resultObj)
        },
        3: (resultChainParams) => {
            let resultObj = {...resultChainParams}
            const metalWeight = getMetalWeight(resultObj.weight, SOLDER_RATES[3])
            resultObj.diameter = Math.pow(15 * metalWeight * (2 * resultObj.k - 1) / resultObj.long / resultObj.density / (2 * resultObj.k + 1), 0.5)
            resultObj.rigelDiameter = resultObj.diameter * resultObj.k
            resultObj.weightNotSolder = Math.pow(resultObj.diameter,2) * resultObj.long * resultObj.density * (2 * resultObj.k + 1) / 15 / (2 * resultObj.k - 1)
            return finalizeCalculation(resultObj)
        },
        4: (resultChainParams) => {
            let resultObj = {...resultChainParams}
            const metalWeight = getMetalWeight(resultObj.weight, SOLDER_RATES[4])
            resultObj.diameter = Math.pow(35 * metalWeight / resultObj.long / resultObj.density , 0.5)
            resultObj.rigelDiameter = resultObj.diameter * resultObj.k
            resultObj.weightNotSolder = Math.pow(resultObj.diameter,2) * resultObj.long * resultObj.density/35
            return finalizeCalculation(resultObj)
        },
        5: (resultChainParams) => {
            let resultObj = {...resultChainParams}
            const metalWeight = getMetalWeight(resultObj.weight, SOLDER_RATES[5])
            const weightFactor = 1.15 * (resultObj.k + 0.43) * 3.14 * 0.386 * 0.01 / resultObj.k
            resultObj.diameter = Math.sqrt(metalWeight / resultObj.long / resultObj.density / weightFactor)
            resultObj.rigelDiameter = resultObj.diameter * resultObj.k
            resultObj.weightNotSolder = 1.15 * (resultObj.rigelDiameter + 0.43 * resultObj.diameter) * 3.14 * 0.386 * Math.pow(resultObj.diameter, 2) * resultObj.density * 0.01 * resultObj.long / resultObj.rigelDiameter
            return finalizeCalculation(resultObj)
        },
        6: (resultChainParams) => {
            let resultObj = {...resultChainParams}
            const metalWeight = getMetalWeight(resultObj.weight, SOLDER_RATES[6])
            resultObj.diameter = Math.pow(6.9 * metalWeight / resultObj.long / resultObj.density , 0.5)
            resultObj.rigelDiameter = resultObj.diameter * resultObj.k
            resultObj.weightNotSolder = Math.pow(resultObj.diameter,2) * resultObj.long * resultObj.density/6.9
            return finalizeCalculation(resultObj)
        },
        7: (resultChainParams) => {
            let resultObj = {...resultChainParams}
            const metalWeight = getMetalWeight(resultObj.weight, SOLDER_RATES[7])
            resultObj.diameter = Math.sqrt(18 * metalWeight / resultObj.long / resultObj.density)
            resultObj.rigelDiameter = resultObj.diameter * resultObj.k
            resultObj.width = resultObj.diameter * 4
            resultObj.thickness = resultObj.diameter * 4
            resultObj.weightNotSolder = Math.pow(resultObj.diameter, 2) * resultObj.long * resultObj.density / 18
            return finalizeCalculation(resultObj)
        },
        8: (resultChainParams) => {
            let resultObj = {...resultChainParams}
            const metalWeight = getMetalWeight(resultObj.weight, SOLDER_RATES[8])
            resultObj.diameter = Math.sqrt(34 * metalWeight / resultObj.long / resultObj.density)
            resultObj.rigelDiameter = resultObj.diameter * resultObj.k
            resultObj.width = resultObj.diameter * 4.1
            resultObj.thickness = resultObj.diameter * 4.1
            resultObj.weightNotSolder = Math.pow(resultObj.diameter, 2) * resultObj.long * resultObj.density / 34
            return finalizeCalculation(resultObj)
        },
        9: (resultChainParams) => {
            let resultObj = {...resultChainParams}
            const metalWeight = getMetalWeight(resultObj.weight, SOLDER_RATES[9])
            resultObj.diameter = Math.sqrt(9.4 * metalWeight / resultObj.long / resultObj.density)
            resultObj.rigelDiameter = resultObj.diameter * resultObj.k
            resultObj.width = resultObj.diameter * 9.2
            resultObj.thickness = resultObj.diameter * 3.85
            resultObj.weightNotSolder = Math.pow(resultObj.diameter, 2) * resultObj.long * resultObj.density / 9.4
            return finalizeCalculation(resultObj)
        },
    };

    const calculate = (chainParams) => {
        const resultChainParams = {
            weight: chainParams.weight,
            long: chainParams.long,
            rigelDiameter: chainParams.rigelDiameter ?? 0,
            diameter: chainParams.diameter ?? 0,
            solder: 0,
            weightWithSolder: 0,
            weightNotSolder: 0,
            k: chainParams.k,
            density: chainParams.density,
            // widthAfter: 0,
            // widthBefore: 0
        }
        return calculations[chainParams.type] ? calculations[chainParams.type](resultChainParams) : 0
    };

    return { calculate };
}
export function createObjectsArray(params) {
    const nameMapping = {
        density: "Плотность",
        diameter: "Диаметр проволоки",
        k: "Коэффициент",
        long: "Длина",
        rigelDiameter: "Диаметр ригеля",
        solder: "Вес припоя",
        weight: "Вес",
        weightNotSolder: "Вес без припоя",
        weightWithSolder: "Вес с припоем",
        width: "Ширина цепи",
        thickness: "Толщина цепи"
    };

    const typeMapping = {
        // weight: "г",
        weightWithSolder: "г",
        weightNotSolder: "г",
        solder: "г",
        long: "см",
        rigelDiameter: "мм",
        diameter: "мм",
        width: "мм",
        thickness: "мм"
    };

    return Object.entries(params).map(([key, value]) => ({
        name: nameMapping[key] || key,
        value,
        type: typeMapping[key] || ""
    }));
}
